/**
 * Theme type definitions for color scheme system.
 */

// Color harmony types based on color theory
export type ColorHarmony =
  | "monochromatic"
  | "complementary"
  | "split-complementary"
  | "triadic"
  | "tetradic"
  | "analogous"
  | "heptadic";

// Individual color definition with HSL values for easy manipulation
export interface ThemeColor {
  hue: number; // 0-360
  saturation: number; // 0-100
  lightness: number; // 0-100
}

// Complete color palette for a theme
export interface ThemePalette {
  // Core 7-color complementary system
  primary: string;
  secondary: string;
  tertiary: string;
  accent: string; // Backward compatible alias for accent1
  accent2: string;
  neutral: string;
  emphasis: string;

  // Background colors
  background: string;
  surface: string;
  surfaceHover: string;

  // Text colors
  textPrimary: string;
  textSecondary: string;
  textMuted: string;

  // Input colors (for modals, forms)
  inputBackground: string;
  inputBorder: string;
  inputText: string;
  inputPlaceholder: string;

  // Status colors
  success: string;
  warning: string;
  error: string;
  info: string;

  // Card type colors
  cardQuestion: string;
  cardAnswer: string;
  cardTreatment: string;

  // Player status colors
  statusThinking: string;
  statusDone: string;
  statusPsychologist: string;

  // Glass overlay
  glassBackground: string;
  glassBorder: string;
}

// Complete theme definition
export interface Theme {
  id: string;
  name: string;
  description: string;
  harmony: ColorHarmony;
  isDark: boolean;
  palette: ThemePalette;
}

// Theme store state
export interface ThemeState {
  currentThemeId: string;
  customTheme: Theme | null;
}

// Default theme ID
export const DEFAULT_THEME_ID = "deep-ocean";
